<template>
  <div></div>
</template>
<script>
import { $EventBus } from '@/eventBus';
import { Auth0Lock } from 'auth0-lock';

export default {
  data: () => ({
    Lock: null,
    lockOptions: {
      language: 'it',
      allowSignUp: false,
      languageDictionary: {
        title: 'Accedi',
        error: {
          signUp: {
            email_is_not_listed: 'You are not allowed to register. Insert a valid email address.',
          },
        },
      },
      theme: {
        logo: process.env.VUE_APP_LOGO_LOGIN,
        primaryColor: process.env.VUE_APP_COLOR_SECONDARY,
        foregroundColor: process.env.VUE_APP_COLOR_SECONDARY,
      },
    },
  }),
  methods: {
    loadLock() {
      // usiamo lock via cdn, il modulo diretto pesa troppo
      const script = document.createElement('script');
      script.setAttribute(
        'src',
        `https://cdn.auth0.com/js/lock/${process.env.VUE_APP_AUTH0_LOCK_VERSION}/lock.min.js`,
      );
      script.async = true;
      script.onload = () => {
        $EventBus.$emit('lockLoaded');
      };
      document.head.appendChild(script);
    },
    reloadLogin() {
      setTimeout(() => {
        location.href = '/login';
      }, process.env.VUE_APP_MESSAGES_TIMEOUT);
    },
  },
  mounted() {
    if (this.$route.query.unauthorized) {
      $EventBus.$emit('message', { type: 'error', text: 'Non hai i permessi per accedere' });
    }
    if (this.$route.query.expired) {
      $EventBus.$emit('message', {
        type: 'error',
        text: this.$t('error.login.expired'),
      });
    }
    this.loadLock();
    $EventBus.$on('lockLoaded', () => {
      this.Lock = new Auth0Lock(
        process.env.VUE_APP_AUTH0_CLIENTID,
        process.env.VUE_APP_AUTH0_DOMAIN,
        {
          configurationBaseUrl: 'https://cdn.eu.auth0.com',
          language: 'it',
          auth: {
            responseType: 'token id_token',
            params: {
              scope: 'openid profile email',
            },
          },
          languageDictionary: {
            forgotPasswordInstructions:
              "Inserisci l'indirizzo email associato al tuo profilo. Riceverai subito un messaggio di posta per configurare la password.",
            forgotPasswordTitle: 'Imposta una nuova password',
            passwordInputPlaceholder: 'password',
            forgotPasswordSubmitLabel: 'IMPOSTA NUOVA PASSWORD',
            emailInputPlaceholder: 'user@example.com',
            usernameOrEmailInputPlaceholder: 'user@example.com',
            loginLabel: 'Accedi',
            loginSubmitLabel: 'Accedi',
            forgotPasswordAction: 'IMPOSTA UNA NUOVA PASSWORD',
            signUpTerms:
              "Acconsento ai <a href='/terms' target='_blank'>termini e condizioni d'uso</a>.",
            title: 'Organizza i dati e crea il tuo sito',
            error: {
              signUp: {
                email_is_not_listed:
                  'You are not allowed to register. Insert a valid email address.',
              },
            },
          },
          mustAcceptTerms: true,
        },
      );
      this.Lock.show(this.lockOptions);
      this.Lock.on('authenticated', (response) => {
        this.Lock.getUserInfo(response.accessToken, (err, profile) => {
          if (err) {
            this.Lock.hide();
            let errorMessage = this.$t('error.login.auth');
            if (err.statusCode === 429) {
              errorMessage = this.$t('error.login.overflow');
            }
            $EventBus.$emit('message', { type: 'error', text: errorMessage });
          } else {
            profile.accessToken = response.accessToken;
            profile.loggedAt = new Date().getTime();
            profile.expires = 36000 * 1000 + new Date().getTime(); // 12h
            profile.idToken = response.idToken;
            // I ruoli utente sono impostati come custom namespaced OIDC claims da una regola su auth0
            // https://auth0.com/docs/scopes/current/custom-claims
            const claim = process.env.VUE_APP_AUTH_OIDC_NAMESPACE;
            profile.roles = profile[claim + 'roles'];
            profile.user_metadata = profile[claim + 'user_metadata'];
            profile.tenants = profile[claim + 'tenants'];
            profile.enabled = profile[claim + 'enabled'];
            profile.langs = profile[claim + 'langs'];
            profile.default_lang = profile[claim + 'default_lang'];
            if (!profile.enabled) {
              $EventBus.$emit('message', { type: 'error', text: 'Il tuo account non è abilitato' });
            } else if (!profile.roles) {
              $EventBus.$emit('message', {
                type: 'error',
                text: 'Non hai un ruolo per accedere all’app',
              });
            } else {
              this.$userLogin(profile);
              this.Lock.hide();
              location.href = '/'; // così rifà il mount di app per recuperare i dati dinemici del menu (corsi)
            }
          }
        });
      });
      this.Lock.on('authorization_error', (err) => {
        console.log('errore autenticazione', err);
        $EventBus.$emit('message', { type: 'error', text: 'Accesso negato' });
      });
      this.Lock.on('forgot_password submit', (response) => {
        console.log(response);
      });
    });
  },
};
</script>

<style>
.auth0-lock.auth0-lock {
  z-index: 10 !important; /* stai sotto ai messaggi */
}
.auth0-lock-close-button {
  display: none; /* nascondi il chiudi */
}
.auth0-lock-name {
  font-style: italic;
  font-size: 18px !important;
}
.auth0-lock-alternative-link {
  font-weight: 700;
  color: #1b1464 !important;
}
.auth0-lock-alternative {
  text-align: left !important;
}
</style>
